import { render } from "./add_attribute.vue?vue&type=template&id=208a883a"
import script from "./add_attribute.vue?vue&type=script&lang=js"
export * from "./add_attribute.vue?vue&type=script&lang=js"

import "./add_attribute.vue?vue&type=style&index=0&id=208a883a&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__